import React from 'react'
import MySpinner from './MySpinner';
import theme from '../theme/theme';

const OverlayLoadingSpinner = ({spinnerColor = theme.colors.primary}) => {
  return (<>
    <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',  
        zIndex: 9999,   
      }} />
  
      {/* Centered spinner */}
      <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10000,  
      }}>
        <MySpinner color={spinnerColor} />
      </div>
      </>
  );
}

export default OverlayLoadingSpinner
